<template>
  <transition name="fade">
    <div class="times">
      <Button
        v-for="(booking, id) in $store.state.availableBookings"
        :key="booking.date"
        link="#form"
        :text="`${booking.label}`"        
        :class="[ booking.date === $store.state.selectedBooking ? 'selected' : '', ...booking.classes ]"        
        :style="`transition-delay:${0 * 50}ms`"
        @click="$store.commit('setSelectedBooking', booking.date)"
        alternateTheme
      />
    </div>
  </transition>
</template>
<script>
import Button from "@/components/AOButton";
export default {
  name: "AvailableTimes",
  components: {
    Button,
  },
};
</script>

<style lang="scss" scoped>
.booked {
  pointer-events: none;
  opacity: 0.5;
  background: var(--ao-dark);
  border:none;
}
.times {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px 30px;
  max-height: calc(max(305px, 35vh));
  background-color: var(--light-green);
  @media (min-width:1160px) {
    max-height: 430px;
  }
  overflow: auto;
  min-width:200px;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--ao-white);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--green);
  }
}
</style>